import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface DashboardKpi {
  value: number;
  change: number | null;
}

export interface DashboardOverview {
  kpis: {
    total_documents: DashboardKpi;
    success_rate: DashboardKpi;
    failed_count: DashboardKpi;
    active_partners: DashboardKpi & { total: number };
    sla_compliance: DashboardKpi & { counts: { compliant: number; exceeded: number } };
    in_process: DashboardKpi;
    outbound_documents: DashboardKpi;
  };
  trend: {
    labels: string[];
    inbound: number[];
    outbound: number[];
  };
  by_status: { label: string; value: number }[];
  by_status_detail: { label: string; value: number }[];
  status_trend: {
    labels: string[];
    series: { name: string; data: number[] }[];
  };
  failures: {
    by_message_type: { label: string; value: number }[];
    by_partner: { name: string; count: number }[];
  };
  by_message_type: { label: string; value: number }[];
  by_file_format: { label: string; value: number }[];
  by_protocol: { label: string; value: number }[];
  top_partners: { name: string; count: number }[];
  ack_status: { label: string; value: number }[];
  recent_activity: {
    document_id: number;
    code: string | null;
    remark: string | null;
    status: string | null;
    created_on: string;
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  baseUrl = environment.baseApiUrl;

  constructor(private http: HttpClient) {}

  getDashboardOverview(range: string = 'all'): Observable<DashboardOverview> {
    return this.http.get<DashboardOverview>(this.baseUrl + 'edi/v1/dashboard/overview', {
      params: { range }
    });
  }
}
